import { createSignal } from "solid-js"
import { EraseTileOption } from "../../lib/core/map_editor/erase_map_tile"
import createSharedCachedFactory from "../memo/createSharedCachedFactory"
import { createEraseTileOption } from "../../lib/core/map_editor/erase_map_tile"
import { isPlainObjDeeplyEqual } from "../../lib/isPlainObjDeeplyEqual"

export const useEraseTileOptionSignal = createSharedCachedFactory((
    // engine: Engine
) => {

    // eslint-disable-next-line solid/reactivity
    const signal = createSignal<EraseTileOption>(createEraseTileOption(), {
        equals: isPlainObjDeeplyEqual,
    })

    return signal
})
